// Identité légale de l'éditeur, centralisée ici : les pages Mentions légales,
// CGU, CGV, Confidentialité et Sous-traitance lisent toutes ce fichier.
//
// Les valeurs laissées à null sont AFFICHÉES en rouge sur les pages, avec la
// mention « à compléter ». Ce sont des informations juridiquement engageantes
// (art. 6-III LCEN) : elles doivent être renseignées avec les valeurs réelles
// avant toute mise en ligne. Ne pas inventer.

export const EDITEUR = {
  nomCommercial: 'Jalonne',

  // Entreprise individuelle : depuis la loi du 14 février 2022, la dénomination
  // doit être composée du nom de l'entrepreneur précédé ou suivi de « EI »
  // (art. R. 526-27 du code de commerce).
  raisonSociale: 'Esteban De Oliveira EI',
  formeJuridique: 'Entrepreneur individuel (micro-entreprise)',
  entrepriseIndividuelle: true, // masque les mentions réservées aux sociétés (capital, RCS)

  // Adresse de l'établissement principal, déclarée au Guichet unique.
  siege: '32 rue de Paris, 92100 Boulogne-Billancourt, France',

  // Une entreprise individuelle exerçant une activité libérale est immatriculée
  // au Registre national des entreprises, pas au RCS.
  registre: 'Registre national des entreprises (RNE)',
  siren: '105 381 388', // clé de Luhn vérifiée
  // Le SIRET (SIREN + 5 chiffres de l'établissement) n'est pas exigé par la
  // LCEN : le numéro d'immatriculation suffit. Renseigné, il s'affiche en plus.
  siret: null,

  // Franchise en base : pas de TVA facturée, pas de numéro intracommunautaire à
  // publier, mais la mention de l'article 293 B du CGI est obligatoire.
  franchiseTva: true,
  tvaIntracom: null,

  directeurPublication: 'Esteban De Oliveira',

  // Adresse dédiée, préférée à une adresse personnelle sur des pages publiques.
  email: 'e.deoliveira@devisapp.fr',
  telephone: '06 71 27 25 33',
};

// Hébergeur du site : nom, adresse et téléphone sont obligatoires (LCEN).
export const HEBERGEUR = {
  nom: 'OVH SAS',
  adresse: '2 rue Kellermann, 59100 Roubaix, France',
  telephone: '1007',
  siteWeb: 'www.ovhcloud.com',
};

// Contact pour l'exercice des droits RGPD. Un DPO n'est pas obligatoire ici,
// mais un point de contact identifié l'est.
export const PROTECTION_DONNEES = {
  contactEmail: 'e.deoliveira@devisapp.fr', // même adresse que l'éditeur, faute de boîte dédiée
  dpoDesigne: false,
  dpoNom: null,
  adressePostale: '32 rue de Paris, 92100 Boulogne-Billancourt, France',
};

// Sous-traitants ultérieurs réellement utilisés par la plateforme.
// Cette liste est reprise telle quelle dans la politique de confidentialité et
// dans l'accord de sous-traitance : la tenir à jour est une obligation (art. 28).
export const SOUS_TRAITANTS = [
  {
    nom: 'Brevo',
    role: 'Acheminement des emails transactionnels (connexion, mot de passe oublié, suivi de chantier, rapports)',
    donnees: 'Adresse email du destinataire, contenu du message',
    localisation: 'Union européenne',
  },
  {
    nom: 'OVH SAS',
    role: 'Hébergement de l\'application, de la base de données et des photos',
    donnees: 'Ensemble des données de la plateforme',
    localisation: 'Union européenne (France)',
  },
];

// Date de dernière mise à jour affichée en tête de chaque document.
// À modifier à chaque révision de fond.
export const DERNIERE_MAJ = '29 septembre 2026';

// Le service est réservé aux professionnels : ce choix conditionne plusieurs
// clauses des CGV (rétractation, médiation, juridiction compétente).
export const CLIENTELE_PROFESSIONNELLE = true;

// Régime de TVA des prix du contrat : 'HT' ou 'TTC'.
// En franchise en base, le prix affiché est celui effectivement payé.
export const PRIX_AFFICHES = 'TTC';

// Délai de préavis de résiliation, en jours avant l'échéance mensuelle.
export const PREAVIS_RESILIATION_JOURS = 0; // 0 = résiliable jusqu'au jour de l'échéance
